import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse,HttpHeaders } from '@angular/common/http';

import { tap, map } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { settings } from './../../settings/settings';
import { User } from '../../models/user/user';

import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _hasStore: boolean = null;
  private apiUrl = environment.apiUrl;
  constructor(
    private http: HttpClient,

    private router:Router
  ) {
  }
  getToken(): string {
    return localStorage.getItem(settings.userToken)
  }
  getCorporateId(): string {
    const corporateId = localStorage.getItem(settings.corporateId);
    if (corporateId) return corporateId;
    return "";
  }
  getProfile() {
   // const requestUrl = '/api/User/GetUserByToken';
    const requestUrl = `${this.apiUrl}/api/User/GetUserByToken`;
    var corpid= this.getCorporateId();
var taken=this.getToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Corporate-Id': corpid,
      'corpId': corpid,
      'UserToken':taken
    });
    return this.http.get<User>(requestUrl,{headers}).pipe(
      map((data : any)=>{
        const user : User ={
          userId : data.userId,
          companyId : data.companyId,
          companyName : data.companyName,
          userName:data.userName,
          whid:data.whid
        };
        return user
      })
    );
  }

  getUserPublicProfile() {
    const requestUrl = '/api/User/PublicProfile';
    return this.http.get<User>(requestUrl);
  }

  private currentUser(): User {
    return JSON.parse(localStorage.getItem(settings.currentUser)) as User;
  }

}
